import React from 'react';
import { useCookies } from 'react-cookie';
import { useLocation, Navigate } from 'react-router';
import { NOSH_AUTH_DATA_KEY } from '../config/Keys';

interface NoLogRouteProps {
  children: React.ReactNode;
  redirectPath?: string;
}

const NoLogRoute: React.FC<NoLogRouteProps> = ({ children, redirectPath = '/' }) => {
  const [cookies] = useCookies();
  const location = useLocation();

  if (!cookies[NOSH_AUTH_DATA_KEY]) {
    return <>{children}</>;
  }

  return <Navigate to={redirectPath} state={{ from: location }} replace />;
};

export default NoLogRoute;
